/**
 * Saved Posts Page
 * Lists posts the current user has bookmarked.
 */

import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthenticationContext';
import SinglePostDisplay from '../components/post/SinglePostDisplay';

const SavedPostsPage = () => {
  const { token } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSaved = useCallback(async () => {
    try {
      const res = await axios.get('/api/posts/bookmarks');
      setPosts(res.data);
    } catch (error) {
      console.error('Error fetching saved posts:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (token) fetchSaved();
    else setLoading(false);
  }, [token, fetchSaved]);

  if (!token) {
    return (
      <div className="container">
        <h1>Saved</h1>
        <div className="no-posts"><p><Link to="/login">Log in</Link> to save posts.</p></div>
      </div>
    );
  }

  if (loading) {
    return <div className="container loading">Loading saved posts...</div>;
  }

  return (
    <div className="container">
      <h1>Saved</h1>
      {posts.length === 0 ? (
        <div className="no-posts"><p>No saved posts yet. Tap the bookmark icon on any post to save it.</p></div>
      ) : (
        <div className="posts-list">
          {posts.map((post) => (
            <SinglePostDisplay key={post._id} post={post} onUpdate={fetchSaved} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SavedPostsPage;
